/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Timeline_Zoom_OutInputs */

const en_shortcut_keys_name_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoom Out`)
};

const fr_shortcut_keys_name_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dezoomer`)
};

const de_shortcut_keys_name_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herauszoomen`)
};

const it_shortcut_keys_name_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimpicciolisci`)
};

const ru_shortcut_keys_name_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отдалиться`)
};

const es_shortcut_keys_name_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alejar`)
};

const zh_cn2_shortcut_keys_name_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`缩小`)
};

const ja_shortcut_keys_name_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ズームアウト`)
};

const hi_shortcut_keys_name_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ज़ूम आउट`)
};

const pt_pt2_shortcut_keys_name_timeline_zoom_out = /** @type {(inputs: Shortcut_Keys_Name_Timeline_Zoom_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diminuir o zoom`)
};

/**
* | output |
* | --- |
* | "Zoom Out" |
*
* @param {Shortcut_Keys_Name_Timeline_Zoom_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_timeline_zoom_out = /** @type {((inputs?: Shortcut_Keys_Name_Timeline_Zoom_OutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Timeline_Zoom_OutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_timeline_zoom_out(inputs)
	if (locale === "de") return de_shortcut_keys_name_timeline_zoom_out(inputs)
	if (locale === "it") return it_shortcut_keys_name_timeline_zoom_out(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_timeline_zoom_out(inputs)
	if (locale === "es") return es_shortcut_keys_name_timeline_zoom_out(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_timeline_zoom_out(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_timeline_zoom_out(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_timeline_zoom_out(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_timeline_zoom_out(inputs)
	return en_shortcut_keys_name_timeline_zoom_out(inputs)
});